import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import { useCollaboratorInvitations } from '../../../../../../hooks/api/useCollaboratorInvitations';
import getName from '../../../../../../utils/getName';
import { APITypes } from '../../../../../../primary-record-types';
import LargeAlertPaper from '../../../../../v2BaseComponents/LargeAlertPaper';

const intl = getIntl('profiles-invitations-alert', {
    header: 'Profile Collaboration Invitation',
    message:
        'You’ve been invited by {inviterName} to be a collaborator for {profileName}’s Profile. Click the profile to Accept or Reject ',
});

export type InvitationAlertOwnProps = {};

export type InvitationAlertProps = InvitationAlertOwnProps;

export const getHasInvitations = (invitations: APITypes.medicalProfileService.CollaboratorInviteListItem[]) => {
    return invitations.length > 0;
};

const InvitationAlert: React.FC<InvitationAlertProps> = () => {
    const { invitations } = useCollaboratorInvitations({});
    if (!getHasInvitations(invitations)) return null;

    const oldestInvitation = invitations[0];

    if (!oldestInvitation) return null;

    const inviterName = getName({
        firstName: oldestInvitation.invitedByFirstName,
        lastName: oldestInvitation.invitedByLastName,
    });
    const profileName = getName(oldestInvitation.medicalProfile);
    return (
        <LargeAlertPaper
            icon="UserPlus"
            title={intl('header')}
            message={intl('message', { inviterName, profileName })}
        />
    );
};

export default React.memo(InvitationAlert);
